import getConfig from 'next/config'

import type { AdyenContext } from '@grandvisionhq/payments'

const { publicRuntimeConfig } = getConfig()
const adyen = publicRuntimeConfig.adyen ?? {}

export const getAdyenConfig = (): AdyenContext => ({
  clientKey: adyen.clientKey,
  environment: adyen.environment,
  config: {
    bancontactCard: {
      hasHolderName: true,
      holderNameRequired: true,
      brands: ['bcmc', 'mc'],
    },
    creditcard: {
      hasHolderName: true,
      holderNameRequired: true,
      brands: ['bcmc', 'mc', 'maestro', 'visa', 'amex'],
    },
    googlepay: {
      allowedAuthMethods: ['CRYPTOGRAM_3DS', 'PAN_ONLY'],
      allowedCardNetworks: ['MASTERCARD', 'VISA'],
      environment: adyen.gPayEnvironment,
      merchantName: 'Pearle',
    },
  },
})
